export enum HotelTagEnum {
  FCDOApprovedHotel = 'FCDO Approved Hotel',
  AccessibleRoom = 'Accessible Room'
}
